<template>
  <div
    class="process-management-content"
    v-draggable="{
      meta: {
        ...targetList,
        _type: 'source'
      }
    }"
    :draggable="canDrag"
    id="my-documents-drag"
  >
    <div class="program-content">
      <div class="program-content-header">
        <a-icon type="code" style="margin-right: 4px" />
        {{ $t('page_dnc_source_processing_program') }}
      </div>
      <div id="program-content-list" class="program-content-list">
        <template v-if="fileType === 'list'">
          <source-table
            @onSelectChange="(value) => onProgramChange(value)"
            :selectedRowKeys="programRowKeys"
            :columns="columns"
            :dataSource="programList"
            @clickFile="(value) => clickProgramFile(value)"
            @dblclickFile="(value) => dblclickFile(value)"
          ></source-table>
        </template>
        <div class="program-content-file-box" v-else>
          <template v-for="(item, index) in programList">
            <file
              :key="index"
              :file="item"
              :selectedRowKeys="programRowKeys"
              @check="(value) => checkProgram(value)"
              @clickFile="(value) => clickProgramFile(value)"
              @dblclickFile="(value) => dblclickFile(value)"
            ></file>
          </template>
        </div>
      </div>
    </div>
    <div class="documents-content">
      <div class="documents-content-header">
        <a-icon type="wallet" style="margin-right: 4px" />
        {{ $t('page_dnc_source_process_documents') }}
      </div>
      <div id="documents-content-list" class="documents-content-list">
        <template v-if="fileType === 'list'">
          <source-table
            @onSelectChange="(value) => onFileChange(value)"
            @clickFile="(value) => clickFileFile(value)"
            @dblclickFile="(value) => dblclickFile(value)"
            :selectedRowKeys="fileRowKeys"
            :columns="columns"
            :dataSource="fileList"
          ></source-table>
        </template>
        <div class="documents-content-file-box" v-else>
          <template v-for="(item, index) in fileList">
            <file
              :key="index"
              :file="item"
              :selectedRowKeys="fileRowKeys"
              @check="(value) => checkFile(value)"
              @clickFile="(value) => clickFileFile(value)"
              @dblclickFile="(value) => dblclickFile(value)"
            ></file>
          </template>
        </div>
      </div>
    </div>
    <div id="coverup">
      <div class="coverup-aaac">
        <a-icon type="copy" style="font-size: 80px" />
        <div class="coverup-length">
          <div class="coverup-length-span">
            {{ targetList.length }}
          </div>
        </div>
      </div>
    </div>
    <preview-modal
      :visible="previewVisible"
      :data="previewData"
      @close="closePreview"
    ></preview-modal>
  </div>
</template>

<script>
import PreviewModal from '../../../components/PreviewModal.vue'
import SourceTable from '../FileList/SourceTable.vue'
import File from '../FileList/File.vue'
import { ResourceServiceProxy } from '@/service-proxies/app-v2/dnc.service-proxies'

const rsp = new ResourceServiceProxy()
export default {
  components: {
    SourceTable,
    PreviewModal,
    File
  },
  data() {
    return {
      columns: [
        {
          title: this.$t('page_my_document_filenm'),
          dataIndex: 'name',
          ellipsis: true,
          scopedSlots: { customRender: 'name' }
        },
        {
          title: this.$t('page_my_document_size'),
          dataIndex: 'contentLength',
          width: 88,
          ellipsis: true,
          scopedSlots: { customRender: 'contentLength' }
        },
        {
          title: this.$t('page_my_document_type'),
          dataIndex: 'fileType',
          key: 'fileType',
          customRender: (text) => {
            return text == 1
              ? this.$t('page_my_document_program')
              : this.$t('page_my_document_process')
          }
        }
      ],
      programList: [],
      fileList: [],
      dataSource: [],
      fileRowKeys: [],
      programRowKeys: [],
      canTransmission: true,
      targetList: [],
      previewVisible: false,
      previewData: {}
      // canDrag: true
    }
  },
  props: {
    fileType: {
      type: String,
      default: 'file'
    },
    selectedKey: {
      // 选择树节点
      type: String,
      default: ''
    },
    keyWords: {
      type: String,
      default: ''
    }
  },
  computed: {
    canDrag() {
      return this.targetList && this.targetList.length > 0
    }
  },
  mounted() {
    const test = document.getElementById('my-documents-drag')
    test.addEventListener(
      'dragstart',
      (e) => {
        // e.preventDefault()
        var dt = e.dataTransfer
        if (dt && this.targetList.length > 0) {
          const item = document.getElementById('coverup')
          var crt = item.cloneNode(true)
          crt.className = 'aa-extra-box'
          crt.id = 'aa-extra'
          document.body.appendChild(crt)
          e.dataTransfer.setDragImage(crt, 0, 0)
          e.dataTransfer.setData('Text', JSON.stringify(this.targetList))
        }
      },
      false
    )
    test.addEventListener(
      'dragend',
      (e) => {
        const div = document.getElementById('aa-extra')
        if (div) {
          document.body.removeChild(div)
        }
      },
      false
    )
  },
  watch: {
    selectedKey: {
      handler() {
        if (this.selectedKey.length) this.getData()
      },
      immediate: true,
      deep: true
    },
    programRowKeys: {
      handler() {
        const fiList = this.fileList.filter((res) => this.fileRowKeys.indexOf(res.id) != -1)
        const promList = this.programList.filter((res) => this.programRowKeys.indexOf(res.id) != -1)
        const targetList = [...fiList, ...promList]
        this.targetList = targetList
        this.$emit('doTransmission', targetList)
      },
      immediate: true,
      deep: true
    },
    fileRowKeys: {
      handler() {
        const fiList = this.fileList.filter((res) => this.fileRowKeys.indexOf(res.id) != -1)
        const promList = this.programList.filter((res) => this.programRowKeys.indexOf(res.id) != -1)
        const targetList = [...fiList, ...promList]
        this.targetList = targetList
        this.$emit('doTransmission', targetList)
      },
      immediate: true,
      deep: true
    },
    keyWords: {
      handler() {
        if (this.keyWords.length) {
          if (this.dataSource && this.dataSource.length) {
            this.programList = this.dataSource.filter(
              (res) => res.fileType == 1 && res.name.indexOf(this.keyWords) !== -1
            )
            this.fileList = this.dataSource.filter(
              (res) => res.fileType == 2 && res.name.indexOf(this.keyWords) !== -1
            )
          }
        } else {
          if (this.dataSource && this.dataSource.length) {
            this.programList = this.dataSource.filter((res) => res.fileType == 1)
            this.fileList = this.dataSource.filter((res) => res.fileType == 2)
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    checkProgram(file) {
      if (this.programRowKeys.indexOf(file.id) === -1) {
        this.programRowKeys.push(file.id)
      } else {
        const rowKeys = this.programRowKeys
        this.programRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickProgramFile(file) {
      this.programRowKeys = [file.id]
    },
    checkFile(file) {
      if (this.fileRowKeys.indexOf(file.id) === -1) {
        this.fileRowKeys.push(file.id)
      } else {
        const rowKeys = this.fileRowKeys
        this.fileRowKeys = rowKeys.filter((res) => res.indexOf(file.id) === -1)
      }
    },
    clickFileFile(file) {
      this.fileRowKeys = [file.id]
    },
    dblclickFile(file) {
      this.previewVisible = true
      this.previewData = file
    },
    closePreview() {
      this.previewVisible = false
    },
    onProgramChange(programRowKeys) {
      this.programRowKeys = programRowKeys
    },
    onFileChange(fileRowKeys) {
      this.fileRowKeys = fileRowKeys
    },
    async getData() {
      this.programList = []
      this.fileList = []
      this.dataSource = []
      this.loading = true
      const data = await rsp.resourceFileList(this.selectedKey)
      if (data && data.length) {
        const dataSource = data.map((res) => {
          res['name'] = res.displayName
          return res
        })
        this.dataSource = dataSource
        this.programList = dataSource.filter((res) => res.fileType == 1)
        this.fileList = dataSource.filter((res) => res.fileType == 2)
      }
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.process-management-content {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 8px;
  height: calc(100% - 40px);
  width: 100%;
  .program-content {
    background-color: #f8f8f8;
    border: solid 1px #52c41a;
    width: calc(50% - 4px);
    height: 100%;
    border-radius: 2px;
    &-header {
      border-bottom: solid 1px #52c41a;
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #f6ffed;
      color: #52c41a;
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    &-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }

  .documents-content {
    background-color: #f8f8f8;
    border: solid 1px #597ef7;
    width: calc(50% - 4px);
    height: 100%;
    border-radius: 2px;
    &-header {
      border-bottom: solid 1px #597ef7;
      padding: 8px 16px;
      font-size: 16px;
      letter-spacing: 0px;
      background-color: #f0f5ff;
      color: #597ef7;
    }
    &-list {
      padding: 8px;
      height: calc(100% - 41px);
      overflow-y: auto;
    }
    &-file-box {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: flex-start;
    }
  }
}
#coverup {
  background-color: #ffffff;
  width: 105px;
  height: 105px;
  position: absolute;
  top: -2500px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coverup-aaac {
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.coverup-length {
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  z-index: 8;
  &-span {
    background-color: rgba(74, 144, 226, 0.85);
    color: #ffffff;
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.aa-extra-box {
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  width: 105px;
  height: 105px;
  position: absolute;
  top: -2500px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
